






































import Vue from 'vue'
import bus from '../model/bus'
import { read, download } from '../helper'
import Game from '../model/Ark/Game'

export default Vue.extend({
    name: 'Home',
    data() {
        return {
            bus,
            text: '',
        }
    },
    methods: {
        load(event) {
            const file = event.target.files[0]
            read(file, json => {
                if (!json.version) {
                    this.$bvToast.toast('Invalid file!', { title: 'Error', variant: 'danger', solid: true })
                    return
                }

                try {
                    bus.game.clear()
                    bus.game.load(json)
                    this.$bvToast.toast('Success!', { title: 'Info', variant: 'success', solid: true })
                } catch (error) {
                    this.$bvToast.toast(error.message, { title: 'Error', variant: 'danger', solid: true })
                }
            })
        },
        update(event) {
            const file = event.target.files[0]
            read(file, json => {
                try {
                    bus.update(json)
                    this.$bvToast.toast('Success!', { title: 'Info', variant: 'success', solid: true })
                } catch (error) {
                    this.$bvToast.toast(error.message, { title: 'Error', variant: 'danger', solid: true })
                }
            })
        },
        save() {
            const json = JSON.stringify(bus.game)
            download('loot.json', json)
        },
        deploy() {
            this.text = bus.game.deploy()
            this.$bvModal.show('deploy-modal')
        },
    },
})
